// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__Jsyfy","success":"Notification_success__meAuG","error":"Notification_error__HLsYL"};